import { Layout } from "antd";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ModalNotice } from "../../components/organisms/Notice/Modal";
import { getToken } from "../../shared/utils";

const AuthRoute: React.FC = () => {
  return getToken("repairshop_user") ? (
    <Layout style={{ overflowY: "hidden" }}>
      <ModalNotice />

      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/login" />
  );
};
export default AuthRoute;
